// Handlers
import handleColorSubmission from './handleColorSubmission';

// Constants
import { HANDLER_RETURN_VALUES } from '../../draftjsConstants';

export const createColorConverterPlugin = () => ({
    handleReturn: (event, editorState, { getProps }) =>
        handleColorSubmission(editorState, getProps) ? HANDLER_RETURN_VALUES.handled : HANDLER_RETURN_VALUES.notHandled,
    onBlur: (event, { getEditorState, getProps }) => {
        const editorState = getEditorState();
        handleColorSubmission(editorState, getProps);
    },
});
